
import "styles/App.css";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Banner from "components/headers/Banner";
import HospitalHeader from "components/headers/HospitalHeader";
import HospitalFooter from "components/footers/HospitalFooter";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Cookies from "universal-cookie";

const cookies = new Cookies();

function AdminHome() {
  const navigate = useNavigate();

  let starViewPath = cookies.get("start_view_path");

  return (
    <>
      <Banner />
      <div>
        <HospitalHeader />
        <div id="home-container">
          <Stack direction="row" justifyContent="left" alignItems="center" className="mb-3">
            <Button type="button" variant="outlined" onClick={() => navigate(starViewPath)}>
              Go to Dashboard
            </Button>
          </Stack>
          <Outlet />
        </div>
        <HospitalFooter />
      </div></>);
}

export default AdminHome;
